import {
  GET_LABREQUESTCALENDAR_FAIL,
  GET_LABREQUESTCALENDAR_SUCCESS,
  GET_LABREQUESTCALENDARS_FAIL,
  GET_LABREQUESTCALENDARS_SUCCESS,
  ADD_LABREQUESTCALENDAR_SUCCESS,
  ADD_LABREQUESTCALENDAR_FAIL,
  UPDATE_LABREQUESTCALENDAR_SUCCESS,
  UPDATE_LABREQUESTCALENDAR_FAIL,
  DELETE_LABREQUESTCALENDAR_SUCCESS,
  DELETE_LABREQUESTCALENDAR_FAIL,  
  SET_STATE_LABREQUESTCALENDAR
} from "./actionTypes";

const INIT_STATE = {
  labRequestCalendars: [],
  labRequestCalendar: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestCalendars = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTCALENDARS_SUCCESS:
      return {
        ...state,
        labRequestCalendars: action.payload.labRequestCalendars,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTCALENDAR:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTCALENDARS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTCALENDAR_SUCCESS:
      return {
        ...state,
        labRequestCalendars: [...state.labRequestCalendars, action.payload],
      };

    case ADD_LABREQUESTCALENDAR_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTCALENDAR_SUCCESS:
      return {
        ...state,
        labRequestCalendars: state.labRequestCalendars.map(labRequestCalendar =>
          labRequestCalendar.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestCalendar }
            : labRequestCalendar
        ),
      };

    case UPDATE_LABREQUESTCALENDAR_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTCALENDAR_SUCCESS:
      return {
        ...state,
        labRequestCalendars: state.labRequestCalendars.filter(
          labRequestCalendar => labRequestCalendar.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTCALENDAR_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTCALENDAR_SUCCESS:
      return {
        ...state,
        labRequestCalendar: action.payload,
      };

    case GET_LABREQUESTCALENDAR_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestCalendars;
